import React from 'react';
import { Table, Icon, Loader } from 'semantic-ui-react';
import DownloadFromRef from '../../../common/DownloadFromRef';

class FileTableErrorCell extends React.Component {
  constructor(props) {
    super(props);

    this.state = {downloadingError: false};

    this.downloadError = this.downloadError.bind(this);
    this.doneDownloadingError = this.doneDownloadingError.bind(this);    
  }

  downloadError() {
    this.setState({downloadingError: true});    
    const ref = 'errors/'+this.props.tour_operator+'/'+this.props.uid+'/'+this.props.uploadId;
    let fn =  "Transavia_PQ_Error.csv";
    DownloadFromRef(ref, fn, this.doneDownloadingError);
  }

  doneDownloadingError() {
    this.setState({downloadingError: false});
  }

  render() {
    let errormsg = "Unknown error";
    if (this.props.error === "ERROR_INPUTFORMAT")       errormsg = "Invalid input";
    else if (this.props.error === "ERROR_FLIGHTSNOCAP") errormsg = "No capacity on flights";
    else if (this.props.error === "ERROR_ALREADYFINAL") errormsg = "Flights already final";

    let optionalattr = {};
    if (errormsg !== "Unknown error") {
      optionalattr.className = "tp-download-original";
      optionalattr.onClick = this.downloadError;
    }

    return (
      <Table.Cell colSpan={this.props.colSpan} singleLine textAlign="center" error {...optionalattr}>
        {this.state.downloadingError
          ? <Loader active size="tiny" inline />
          : <Icon name="warning circle" />
        }
        {errormsg}
      </Table.Cell>
    )
  }
}

export default FileTableErrorCell;


// WEBPACK FOOTER //
// ./src/pages/Home/FileTable/FileTableErrorCell.js